<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="text-white bg-blue" inline-actions>
        سفارش
        <q-badge align="top" color="red" text-color="white" class="q-ml-xs">{{ saleNum }}</q-badge>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-table
          :data="lodash.sortBy(OrderDetailsList, ['Group_Name', 'Goods_Name'])"
          row-key="Sale_Num"
          wrap-cells
          flat
          :hide-header="$q.screen.lt.md"
          :hide-bottom="!$q.screen.lt.md"
          :rows-per-page-options="[0]">
        <template v-slot:header>
          <q-tr class="text-bold">
            <td class="text-center">کد کالا</td>
            <td class="text-center">نام کالا</td>
            <td class="text-center">تعداد</td>
            <td class="text-center">واحد</td>
            <td class="text-center">قیمت واحد</td>
            <td class="text-center">قیمت کل</td>
            <td class="text-center">تخفیف</td>
            <td class="text-center"
                v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))">مبلغ
              واحد خرید روز
            </td>
            <td class="text-center"
                v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))">
              مبلغ کل خرید روز
            </td>
            <td class="text-center"
                v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))">مبلغ
              واحد خرید اصلی
            </td>
            <td class="text-center"
                v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))">
              مبلغ کل خرید اصلی
            </td>
            <td class="text-center"
                v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v))">سود فروش
            </td>
          </q-tr>
          <q-tr class="bg-indigo text-white text-center">
            <td>{{ OrderDetailsList.length }} قلم</td>
            <td></td>
            <td>{{ lodash.sumBy(OrderDetailsList, "SaleG_Count")}}</td>
            <td></td>
            <td></td>
            <td> {{ lodash.sumBy(OrderDetailsList, "SaleG_TotalAll").toLocaleString() }}</td>
            <td></td>
            <td></td>
            <td v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v))">
              {{ lodash.sumBy(OrderDetailsList, item=> item.SaleG_Count * item.BuyDay_Price).toLocaleString() }}
            </td>
            <td v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v))"></td>
            <td v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v))">
              {{ lodash.sumBy(OrderDetailsList, item=> item.SaleG_Count * item.BuyLast_Price).toLocaleString() }}
            </td>
            <td v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v))">
                {{lodash.sumBy(OrderDetailsList, item=> parseInt(item.SaleG_TotalAll - (item.SaleG_Count *  item.BuyDay_Price).toFixed((0)))).toLocaleString()}}
            </td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class text-center" v-if="!$q.screen.lt.md">
            <td>
              <q-chip clickable @click="showProductDetailsDialog(props.row)" square
                      v-if="props.row.Goods_Code!=='109991'" color="red" text-color="white"
                      :label="props.row.Goods_Code"/>
            </td>
            <td class="text-left">
              {{ props.row.Goods_Name }}
              <q-space/>
              <q-chip square dense :label="props.row.Group_Name"/>
            </td>
            <td>
              <q-badge color="indigo" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                {{ props.row.SaleG_Count }}
              </q-badge>
            </td>
            <td>
              <q-badge color="brown" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                {{ props.row.Unit_Name }}
              </q-badge>
            </td>
            <td>
              <q-badge color="teal" class="q-ml-xs">{{ props.row.SaleG_PricePure | toLoalString }} ریال
              </q-badge>
            </td>
            <td>
              <q-badge color="teal-14" class="q-ml-xs">{{ props.row.SaleG_TotalAll | toLoalString }}
                ریال
              </q-badge>
            </td>
            <td v-if="props.row.Goods_Code!=='109991'">
              <q-badge dir="ltr" color="red" text-color="white" :label="`${props.row.SaleG_Off_D_Origin} %`"/>
            </td>
            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && props.row.Goods_Code!=='109991'">
              <q-badge color="indigo" class="q-ml-xs">
                {{ props.row.BuyDay_Price | toLoalString }} ریال
              </q-badge>
            </td>
            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && props.row.Goods_Code!=='109991'">
              <q-badge color="indigo-14" class="q-ml-xs">
                {{ props.row.SaleG_Count * props.row.BuyDay_Price | toLoalString }}
                ریال
              </q-badge>
            </td>
            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  &&  props.row.Goods_Code!=='109991'">
              <q-badge color="indigo" class="q-ml-xs">
                {{ props.row.BuyLast_Price | toLoalString }} ریال
              </q-badge>
            </td>
            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  &&  props.row.Goods_Code!=='109991'">
              <q-badge color="indigo-14" class="q-ml-xs">
                {{ props.row.SaleG_Count * props.row.BuyLast_Price | toLoalString }}
                ریال
              </q-badge>
            </td>

            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v)) && props.row.Goods_Code!=='109991'">
              <q-chip dir="ltr" dense square color="blue-10" text-color="white"
                      :label="parseInt(props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price).toFixed((0))).toLocaleString()">
                <q-badge
                    dir="ltr"
                    class="q-ml-xs"
                    :color="(((props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price))/props.row.SaleG_TotalAll)*100).toFixed(2) > 0 ?'green':'red'"
                    text-color="white"
                    :label="`${(((props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price))/props.row.SaleG_TotalAll)*100).toFixed(2)} %`"/>
              </q-chip>
              ریال
            </td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>

    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>

  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "OrderDetails",
  components: {ProductDetail},
  props: ['saleNum', 'store_id', 'hava_num'],
  data() {
    return {
      selectedProductDetails:[],
      showProductDetails: false,
      selectedCustomer: '',
      OrderDetailsList: [],
      pagination: {
        rowsPerPage: 10
      },
    }
  },
  methods: {
    ...mapActions({
      getDetails: 'Orders/getOrderDetail',
      getOrderDetailByStoreID: 'Orders/getOrderDetailByStoreID',
      getCustomerInfo: 'Customers/get_customer_info',
      getProductInfo: 'Products/getProductInfo'
    }),
    showProductDetailsDialog(row) {
      this.getProductInfo(row.Goods_ID).then((res) => {
        this.selectedProductDetails = res[0];
        this.showProductDetails = true
      })
    },
    getOrderDetailsList(){
      if (this.store_id !==null){
        this.getOrderDetailByStoreID({sale_num: this.saleNum, hava_num: this.hava_num, store_id:this.store_id}).then((res)=>{
          this.OrderDetailsList = res.data;
        });
      }else{
        this.getDetails(this.saleNum).then((res)=>{
          this.OrderDetailsList = res.data;
        });
      }
    }
  },
  created() {
    this.getOrderDetailsList();
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>
